const bytesToMegabytes = (num, round = 3) => (num / 1024 / 1024).toFixed(round);

export default bytesToMegabytes;
